import ApprovalRAE from './ApprovalRAE'

export default ApprovalRAE